import Templates from '@/pages/templatesAdmin/TemplatesAdmin.page'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/templates')({
  component: () => <TemplateLayout />,
  // component: () => <IFramePage url='notification-templates.html' />,
})

const TemplateLayout = () => {
  return (
    <>
      <Templates />
      <Outlet />
    </>
  )
}
